<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :search="search"
          :items="dataTable"
          :items-per-page="-1"
          hide-default-footer
          :mobile-breakpoint="breakpoint"
          :sort-by="'name_route'"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.name_regional="{ item }">
            <a
              class="orange--text caption"
              @click="
                $profile.showProfileDrawer(
                  item.id_regional,
                  'administrator/regionals/getRegional'
                )
              "
            >
              <v-icon color="orange" x-small>mdi-account-tie</v-icon>
              {{ item.name_regional }}
            </a>
          </template>

          <template v-slot:item.name_route="{ item }">
            <a
              class="lime--text caption"
              @click="
                $profile.showProfileDrawer(
                  item.id_route,
                  'administrator/routes/getRoute'
                )
              "
            >
              <v-icon color="lime" x-small>mdi-map</v-icon>
              {{ item.name_route }}
            </a>
          </template>

          <template v-slot:item.name_agent="{ item }">
            <a
              class="blue--text caption"
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'administrator/agents/getAgent'
                )
              "
            >
              <v-icon color="primary" x-small>mdi-account</v-icon>
              {{ item.name_agent }}
            </a>
          </template>

          <!-- VALUES -->
          <template
            v-for="(value, index) in valueColors"
            v-slot:[`item.${value}`]="{ item }"
          >
            <div :key="`${index} ${Math.random()}`">
              <v-chip
                x-small
                v-if="value == 'comission_local'"
                :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : ''"
              >
                {{ typeCommissionText(item.type_comission) }}
              </v-chip>
            </div>
            <span class="caption" :key="index" :class="getColor(item[value])">{{
              item[value]
            }}</span>
          </template>
        </v-data-table>
      </v-card>
      <!-- Resume -->
      <div class="mt-4" v-if="data.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("periodSummary") }}
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr
                      v-for="(item, index) in keysResume"
                      :key="`${index} ${Math.random()}`"
                    >
                      <td class="caption">{{ TranslateKey(item) }}</td>
                      <td class="text-right" :class="resume[item].classColor">
                        {{ resume[item].value }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "administrator-financial-sales-report-collectors",
  components: {
    HeaderPrint,
  },
  data: () => ({
    search: "",
    breakpoint: "xs",
    data: [],
    dataTable: [],
    resume: null,
    resumePrint: "",
    keysResume: [],
    idRegional: "",
    idLocal: "",
    typeList: false,
    toggle_exclusive: undefined,
    endpoint: "",
    valueColors: [
      "sales_bets",
      "cancellations",
      "commission_bets",
      "sales_credits",
      "commission_credits",
      "comission_local",
      "prizes_paid",
      "gross_profit",
      "comission_regional",
      "liquid_profit",
    ],
  }),
  computed: {
    headers() {
      return [
        { text: "Regional", value: "name_regional" },
        { text: this.$t("route"), value: "name_route" },
        { text: this.$t("agent"), value: "name_agent" },
        { text: this.$t("qtyBets"), value: "count_bets", align: " caption" },
        { text: this.$t("salesBets"), value: "sales_bets" },
        { text: this.$t("betCanceled"), value: "cancellations" },
        {
          text: this.$t("coAgentSalesBets"),
          value: "commission_bets",
        },
        {
          text: this.$t("qtyCredits"),
          value: "count_credits",
          align: " caption",
        },
        { text: this.$t("salesCredits"), value: "sales_credits" },
        {
          text: this.$t("coAgentCredit"),
          value: "commission_credits",
        },
        { text: this.$t("awards"), value: "prizes_paid" },
        {
          text: this.$t("coGerLocal"),
          value: "comission_local",
        },
        { text: this.$t("grossProfit"), value: "gross_profit" },
        { text: this.$t("regionalCo"), value: "comission_regional" },
        { text: this.$t("netProfit"), value: "liquid_profit" },
      ];
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_regional() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    id_route() {
      return this.$store.state.filters.autocompleteRoutes.id;
    },
    // id_agent() {
    //   return this.$store.state.filters.autocompleteAgents.id;
    // },
    typeLive() {
      return this.$store.state.filters.groupTypeLive.value;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.getSalesReportRoute();
    },
  },
  methods: {
    reset() {
      this.data = [];
      this.dataTable = [];
      this.idRegional = "";
      this.idLocal = "";
      this.resume = {};
    },
    async getSalesReportRoute() {
      this.reset();
      const body = {
        ...this.rangeDate,
        id_regional: this.id_regional,
        id_route: this.id_route,
        id_agent: "",
        tipo: this.typeLive,
        export: this.exportDoc,
      };

      let response;

      // Request Download DOC (Excel)
      if (this.exportDoc) {
        const extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/administrator/financial/salesReportRoute",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/administrator/financial/salesReportRoute",
          body
        );
      }

      if (!response.dados) {
        this.data = [];
        return;
      }

      this.dataTable = response.dados;
      this.buildGroupedReport(response.dados);
    },

    buildGroupedReport(dados) {
      // De acordo com o type_comission "bruto" ou "ngr" o valor a comissão do Local será alterada
      // Caso seja 'ngr' o valor do somatório será commission_ngr_local
      dados.forEach((item) => {
        if (item.type_comission == "ngr") {
          item.comission_local = (
            Number(item.comission_ngr_local) * -1
          ).toFixed(2);
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = (Number(item.comission_local) * -1).toFixed(2);
        }
      });
      // Fase 1
      // Reformulacao de dados trazidos da API
      // Contruindo estrutura a nível Gerente Regional
      for (let item of dados) {
        // Seto o estado inical do item do this.data
        // Esse itemData vai ser moldado com novos atributos
        // e no final vai ser adicionado no this.data responsável pela listagem
        let itemData = {};

        // Criação de 2 parametros nescessários para a listagem da table
        // São eles: Comissao do Regional, Lucro Líquido
        item.comission_regional = (
          item.gross_profit *
          (item.comission_regional / 100) *
          -1
        ).toFixed(2);
        item.liquid_profit = (
          item.gross_profit -
          item.comission_regional * -1
        ).toFixed(2);

        // Cria as informações a nivel Ger. Regional e
        // cria um array de Ger. Locais de sua rede
        // São eles: id_regional:String, name_regional:String, locals:Array
        if (this.idRegional != item.id_regional) {
          this.idRegional = item.id_regional;
          itemData.name_regional = item.name_regional;
          itemData.id_regional = item.id_regional;
          itemData.locals = [];
        }

        // Adiciona no "Data" Array responsável pela listagem
        itemData.name_regional && this.data.push(itemData);
      }

      // Fase 2
      // Adicionando Ger. Locais da rede de cada Ger. Regional
      for (let item_data of this.data) {
        for (let data of dados) {
          if (data.id_regional == item_data.id_regional) {
            if (this.idLocal != data.id_local) {
              this.idLocal = data.id_local;
              item_data.totalRegional = {};
              item_data.locals.push({
                id_local: data.id_local,
                name_local: data.name_local,
                type_comission: data.type_comission,
                agents: [],
              });
            }
          }
        }
      }

      // Fase 3
      // Adicionando Agents que estão da rede de cada Ger. Local
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          for (let data of dados) {
            if (data.id_local == local_data.id_local) {
              local_data.totalLocal = {};
              local_data.agents.push(data);
            }
          }
        }
      }

      // Soma dos Gerentes Locais
      for (let item_data of this.data) {
        for (let local_data of item_data.locals) {
          let count_bets = 0,
            sales_bets = 0,
            cancellations = 0,
            commission_bets = 0,
            count_credits = 0,
            sales_credits = 0,
            commission_credits = 0,
            comission_local = 0,
            prizes_paid = 0,
            gross_profit = 0,
            comission_regional = 0,
            liquid_profit = 0,
            type_comission = "";

          for (let agent_data of local_data.agents) {
            type_comission = agent_data.type_comission;
            count_bets = count_bets + Number(agent_data.count_bets);
            sales_bets = sales_bets + Number(agent_data.sales_bets);
            cancellations = cancellations + Number(agent_data.cancellations);
            commission_bets =
              commission_bets + Number(agent_data.commission_bets);
            count_credits = count_credits + Number(agent_data.count_credits);
            sales_credits = sales_credits + Number(agent_data.sales_credits);
            commission_credits =
              commission_credits + Number(agent_data.commission_credits);
            comission_local =
              comission_local + Number(agent_data.comission_local);
            prizes_paid = prizes_paid + Number(agent_data.prizes_paid);

            gross_profit = gross_profit + Number(agent_data.gross_profit);
            comission_regional =
              comission_regional + Number(agent_data.comission_regional);
            liquid_profit = liquid_profit + Number(agent_data.liquid_profit);
          }

          local_data.totalLocal.count_bets = count_bets;
          local_data.totalLocal.sales_bets = sales_bets.toFixed(2);
          local_data.totalLocal.cancellations = cancellations.toFixed(2);
          local_data.totalLocal.commission_bets = commission_bets.toFixed(2);
          local_data.totalLocal.count_credits = count_credits;
          local_data.totalLocal.sales_credits = sales_credits.toFixed(2);
          local_data.totalLocal.commission_credits = commission_credits.toFixed(
            2
          );
          local_data.totalLocal.comission_local = comission_local.toFixed(2);

          local_data.totalLocal.prizes_paid = prizes_paid.toFixed(2);
          local_data.totalLocal.gross_profit = gross_profit.toFixed(2);

          local_data.totalLocal.comission_regional = comission_regional.toFixed(
            2
          );
          local_data.totalLocal.liquid_profit = liquid_profit.toFixed(2);
          local_data.totalLocal.type_comission = type_comission;
        }
      }

      // Soma dos Gerentes Regionais
      for (let item_data of this.data) {
        let count_bets = 0,
          sales_bets = 0,
          cancellations = 0,
          commission_bets = 0,
          count_credits = 0,
          sales_credits = 0,
          commission_credits = 0,
          comission_local = 0,
          prizes_paid = 0,
          gross_profit = 0,
          comission_regional = 0,
          liquid_profit = 0;

        for (let local_data of item_data.locals) {
          count_bets = count_bets + Number(local_data.totalLocal.count_bets);
          sales_bets = sales_bets + Number(local_data.totalLocal.sales_bets);
          cancellations =
            cancellations + Number(local_data.totalLocal.cancellations);
          commission_bets =
            commission_bets + Number(local_data.totalLocal.commission_bets);
          count_credits =
            count_credits + Number(local_data.totalLocal.count_credits);
          sales_credits =
            sales_credits + Number(local_data.totalLocal.sales_credits);
          commission_credits =
            commission_credits +
            Number(local_data.totalLocal.commission_credits);

          comission_local =
            comission_local + Number(local_data.totalLocal.comission_local);
          prizes_paid = prizes_paid + Number(local_data.totalLocal.prizes_paid);
          gross_profit =
            gross_profit + Number(local_data.totalLocal.gross_profit);

          comission_regional =
            comission_regional +
            Number(local_data.totalLocal.comission_regional);
          // Tratamento para operação "NGR"
          // Quando a TOTAL LOCAL é positivo o valor no bruto deve ser atualizado
          // É preciso faer uma compensasão do valor da comissão que foi ZERADO
          // Neste trecho abaixo o LUCRO BRUTO da linha - TOTAL LOCAL recebe esta compensação
          if (
            local_data.totalLocal.comission_local > 0 &&
            local_data.type_comission == "ngr"
          ) {
            local_data.totalLocal.gross_profit = (
              Number(local_data.totalLocal.gross_profit) -
              Number(local_data.totalLocal.comission_local)
            ).toFixed(2);
            local_data.totalLocal.liquid_profit = (
              Number(local_data.totalLocal.liquid_profit) -
              Number(local_data.totalLocal.comission_local)
            ).toFixed(2);
            liquid_profit =
              liquid_profit + Number(local_data.totalLocal.liquid_profit);
          } else {
            liquid_profit =
              liquid_profit + Number(local_data.totalLocal.liquid_profit);
          }
        }

        item_data.totalRegional.count_bets = count_bets;
        item_data.totalRegional.sales_bets = sales_bets.toFixed(2);
        item_data.totalRegional.cancellations = cancellations.toFixed(2);
        item_data.totalRegional.commission_bets = commission_bets.toFixed(2);
        item_data.totalRegional.count_credits = count_credits;
        item_data.totalRegional.sales_credits = sales_credits.toFixed(2);
        item_data.totalRegional.commission_credits = commission_credits.toFixed(
          2
        );
        item_data.totalRegional.comission_local = comission_local.toFixed(2);
        item_data.totalRegional.prizes_paid = prizes_paid.toFixed(2);
        // Tratamento para operação "NGR"
        // Quando a TOTAL LOCAL é positivo o valor no bruto deve ser atualizado
        // É preciso fazer uma compensação do valor da comissão que foi ZERADO
        // Neste trecho abaixo o LUCRO BRUTO da linha - TOTAL REGIONAL recebe esta compensação
        if (item_data.totalRegional.comission_local > 0) {
          const commissionLocalOver = [];
          item_data.locals.map((local) => {
            if (Number(local.totalLocal.comission_local) > 0) {
              commissionLocalOver.push(
                Number(local.totalLocal.comission_local)
              );
            }
          });
          const reducer = (accumulator, currentValue) =>
            accumulator + currentValue;
          let sumCommisonLocalOver = commissionLocalOver.reduce(reducer);

          item_data.totalRegional.gross_profit = (
            Number(gross_profit) - Number(sumCommisonLocalOver)
          ).toFixed(2);
        } else {
          item_data.totalRegional.gross_profit = gross_profit.toFixed(2);
        }

        item_data.totalRegional.comission_regional = comission_regional.toFixed(
          2
        );
        item_data.totalRegional.liquid_profit = liquid_profit.toFixed(2);
      }
      // Gerando o resumo apenas depois de fazer os tratamentos
      this.buildResumeData(this.data);
    },
    buildResumeData(data) {
      if (!data) return;
      // console.log(data);
      // Tratamento para quando a operação é "NGR"
      // Quando a operação do gerente local (TOTAL LOCAL) da prejuízo para o operador
      // 1) O Valor do TOTAL LOCAL - comissão do Local é zerada (comission_local), é necessário aplicar essa diferença no lucro bruto (gross_profit)
      // 2) O Valor da comissão do local (comission_local) na linha do agente não é alterado antes do resumo, apenas a UI (cleanPositiveValueUI())
      // 3) Para o resumo é necessário zerar de fato para que não seja contabilizado
      let agents = [];
      let addCompensation = false;
      for (let item of data) {
        for (let local of item.locals) {
          if (
            local.totalLocal.comission_local > 0 &&
            local.totalLocal.type_comission == "ngr"
          ) {
            const compensation = {
              cancellations: 0,
              commission_bets: 0,
              sales_credits: 0,
              commission_credits: 0,
              comission_localUI: 0,
              prizes_paid: 0,
              gross_profit: Number(local.totalLocal.comission_local) * -1,
              comission_regional: 0,
              liquid_profit: Number(local.totalLocal.comission_local) * -1,
              qtdAgents: 0,
              count_credits: 0,
              count_bets: "0",
              sales_bets: "0",
            };
            agents.push(compensation);
            addCompensation = true;
          }
          for (let agent of local.agents) {
            if (local.type_comission == "bruto") {
              agent.comission_localUI = agent.comission_local;
            } else if (
              local.totalLocal.comission_local > 0 &&
              local.type_comission == "ngr"
            ) {
              agent.comission_localUI = "0.00";
              // console.log(agent.gross_profit);
            } else {
              agent.comission_localUI = agent.comission_local;
            }
            agents.push(agent);
          }
        }
      }
      // console.log(agents)

      const sum = (key) => {
        return agents
          .map((item) => Number(item[key]))
          .reduce((a, b) => a + b, 0)
          .toFixed(2);
      };

      let resume = {
        sales_bets: {},
        cancellations: {},
        commission_bets: {},
        sales_credits: {},
        commission_credits: {},
        comission_localUI: {},
        prizes_paid: {},
        gross_profit: {},
        comission_regional: {},
        liquid_profit: {},
      };

      Object.keys(resume).forEach((key) => {
        const total = sum(key);
        resume[key].value = `${total}`;
        resume[key].classColor = this.getColor(total);
      });

      const complement = {
        qtdAgents: {
          value: addCompensation ? agents.length - 1 : agents.length,
        },
        count_credits: { value: Number(sum("count_credits")) },
        count_bets: { value: Number(sum("count_bets")) },
      };

      this.resume = { ...complement, ...resume };
      this.keysResume = Object.keys(this.resume);
    },

    getColor(value) {
      if (value == 0) return "grey--text darken-4";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    TranslateKey: function(key) {
      const myKeysTranslated = {
        qtdAgents: this.$t("numbersOfAgents"),
        comission_regional: this.$t("coRegionalManager"),
        count_bets: this.$t("amountBet"),
        sales_bets: this.$t("bets"),
        cancellations: this.$t("cancelledBets"),
        commission_bets: this.$t("coAgentSalesBets"),
        count_credits: this.$t("qtyCredits"),
        sales_credits: this.$t("credits"),
        commission_credits: this.$t("coAgentCredit"),
        comission_localUI: this.$t("coGerLocal"),
        prizes_paid: this.$t("awards"),
        liquid_profit: this.$t("netProfit"),
        gross_profit: this.$t("grossProfit"),
      };

      return myKeysTranslated[key] || null;
    },
    typeCommissionText(type_comission) {
      const commissionLocal = {
        ngr: "NGR",
        bruto: this.$t("gross"),
      };
      return commissionLocal[type_comission];
    },
  },
  filters: {},
};
</script>
